import { LIVE_BARS, barHeight } from '../../lib/practice'

/**
 * The live strip of design page 6: `LIVE_BARS` bars in the recording red,
 * each the loudness of one window of the microphone's own samples
 * (`hooks/useAudio.js`), filling left to right and scrolling once full.
 * Decorative — the timer beside it is the accessible signal.
 */
export default function LiveWave({ levels = [], bars = LIVE_BARS }) {
  return (
    <div dir="ltr" aria-hidden="true" className="flex h-10 w-full items-center gap-[2px]">
      {Array.from({ length: bars }, (_, index) => (
        <span
          key={index}
          data-live-bar
          className="flex-1 rounded-[2px] bg-bad transition-[height] duration-75"
          style={{ height: `${barHeight(levels[index] ?? 0)}px` }}
        />
      ))}
    </div>
  )
}
